<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <v-container>
            <v-row>
                <v-card elevation="12" style="height: calc(100svh - 2svw - 2svw); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <img src="./../assets/images/Logo_calper_pequeño.png" style="width: 238px; margin-top: 13svw; margin-left: auto; margin-right: auto;" />
                    <p
                        style="margin-top: 25svh; font-family: Lato; font-style: normal; color: #666563; font-size: 20px; font-weight: 400;">
                        Introduce tu código de acceso </p>
                    <v-text-field id="password" v-model="pass" outlined prepend-inner-icon="lock" name="password" :type="show ? 'text' :
                        'password'" :append-icon="show ? 'edit' : 'visibility'" @click:append="show = !show"
                        style=" margin-top: 2svw; margin-left: 5svw; margin-right: 5svw; background: #FFFFFF;">
                    </v-text-field>
                    <div style="display: flex; align-items: flex-end; flex: 1 1 auto">
                      <v-btn elevation="12" v-on:click="checkPassword()"
                          style="margin-left: auto; margin-right: auto; margin-bottom: 7.66svh; width: 208px; height: 69px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                          <b>Entrar</b>
                      </v-btn>
                    </div>
                </v-card>

            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import axios from "axios";
import { nextScreen, nextScreenWithMoreParams } from '../router/utils.js';
import { preference } from "vue-preferences";

const api = require('../../config/conf.env')

export default {
    name: 'AccessCode',
    data() {
        return {
            pass: '',
            token: '',
            show: false,
        }
    },
    methods: {
        async checkPassword() {
            await axios.get(api.partialUrl + api.group, {
                headers: { Authorization: `${this.pass}` }
            }).then((res) => {
                console.log(res.data);
                if (res.data.status == "max_errors") {
                    nextScreen(this.$router, '/maxerror');
                } else {
                    const token = preference('apiToken', { defaultValue: '' });
                    token.set(this.pass);
                    nextScreen(this.$router, '/welcomeinfo');
                }
            }).catch((error) => {
                console.log(error);
                nextScreen(this.$router, '/accesscodeerror');
            });
        },
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/AccessCode.vue